/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Monday, May 2nd 2022, 1:41:49 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { TaskTemplate, Team } from "lib/schemas";
import { OSActionButton, EmptyStateActionWrapper, Image, EmphasisText } from "ui-widgets";

export const EmptyTaskTeamsCTA = ({
  openTeamAccessForm,
  taskTitle,
}: {
  openTeamAccessForm: (team: Team) => void;
  taskTitle: TaskTemplate["title"];
}) => {
  return (
    <EmptyStateActionWrapper
      title={
        <>
          No teams have been granted access to <EmphasisText>{taskTitle}</EmphasisText> yet.
        </>
      }
      description="Granting a team access to this task template allows members of that team to perform, assign or supervise tasks that will be created for this task template during a workflow process instance."
      illustrationGraphic={<Image className="image-style-A" src="/img/old-woman.png" alt="Onestop Admin" />}
    >
      <OSActionButton variant="contained" size="large" onClick={() => openTeamAccessForm(null)}>
        Give a team access to{" "}
        <EmphasisText style={{ padding: "0px 5px 0px 5px" }} color="white">
          {taskTitle}
        </EmphasisText>
      </OSActionButton>
    </EmptyStateActionWrapper>
  );
};
